/* eslint-disable import/no-internal-modules */
import { isEmpty, startCase } from 'lodash';
import sortBy from 'lodash/sortBy';
import {
  ArrField,
  ProjectFeeField,
} from 'components/organisms/dashboard/use-filter-fields';
import {
  FilterableField,
  filterableFieldType,
} from 'components/organisms/tasks/fields';
import { ProjectTemplateData } from './types';

export const findLowestStartDay = (data: ProjectTemplateData[]): number =>
  data.reduce(
    (min, p) => (p.startDay < min ? p.startDay : min),
    data[0]?.startDay || 1,
  );

export const findLargestSumOfStartDayDuration = (
  data: ProjectTemplateData[],
): number => {
  const { duration, startDay } = data.reduce((prev, p) => {
    const currentTaskSum = p.startDay + p.duration;
    const prevTaskSum = prev.startDay + prev.duration;

    return currentTaskSum > prevTaskSum ? p : prev;
  }, data[0] || { duration: 0, startDay: 1 });

  return startDay + duration;
};

export const insert = <T>(arr: T[], index: number, newItem: T): T[] => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index),
];

const EMPTY_ARRAY = [];

export const getDynamicConditionFields = (
  projectCustomFields,
): FilterableField[] => {
  return isEmpty(projectCustomFields)
    ? EMPTY_ARRAY
    : sortBy(
        [
          ArrField,
          ProjectFeeField,
          ...projectCustomFields.map((x) => ({
            ...x,
            type: filterableFieldType(x),
          })),
        ].filter((x) => Boolean(x)) as FilterableField[],
        ({ fieldLabel, fieldName }) => fieldLabel ?? startCase(fieldName),
      );
};
